import { createContext } from 'react';

export const HostInfoContext = createContext(null);

